import { PersonalPropertyType } from "@covertree/new-business-graphql";

/** Ordered as rendered in the item type dropdown. */
const personalPropertyValues: Record<
  PersonalPropertyType,
  { label: string; icon: string }
> = {
  [PersonalPropertyType.Jewelry]: {
    label: "Jewelry",
    icon: "/images/coverage-icons/personal-property/jewelry.webp",
  },
  [PersonalPropertyType.GunsAndAmmunition]: {
    label: "Guns and Ammunition",
    icon: "/images/coverage-icons/personal-property/guns.webp",
  },
  [PersonalPropertyType.FineArts]: {
    label: "Fine Arts",
    icon: "/images/coverage-icons/personal-property/arts.webp",
  },
  [PersonalPropertyType.StampsBooks]: {
    label: "Stamps/Books",
    icon: "/images/coverage-icons/personal-property/stamps.webp",
  },
  [PersonalPropertyType.CameraRecorderMedia]: {
    label: "Camera/Recorder/Media",
    icon: "/images/coverage-icons/personal-property/camera.webp",
  },
  [PersonalPropertyType.RareAndCurrentCoins]: {
    label: "Rare and Current Coins",
    icon: "/images/coverage-icons/personal-property/coins.webp",
  },
  [PersonalPropertyType.ComputerEquipment]: {
    label: "Computer Equipment",
    icon: "/images/coverage-icons/personal-property/computer.webp",
  },
  [PersonalPropertyType.Furs]: {
    label: "Furs",
    icon: "/images/coverage-icons/personal-property/furs.webp",
  },
  [PersonalPropertyType.GolfersEquipment]: {
    label: "Golfer's Equipment",
    icon: "/images/coverage-icons/personal-property/golfers-equipment.webp",
  },
  [PersonalPropertyType.MusicalInstruments]: {
    label: "Musical Instruments",
    icon: "/images/coverage-icons/personal-property/instruments.webp",
  },
  [PersonalPropertyType.Silverware]: {
    label: "Silverware",
    icon: "/images/coverage-icons/personal-property/silverware.webp",
  },
  [PersonalPropertyType.Tools]: {
    label: "Tools",
    icon: "/images/coverage-icons/personal-property/tools.webp",
  },
  [PersonalPropertyType.Bikes]: {
    label: "Bikes",
    icon: "/images/coverage-icons/personal-property/bikes.webp",
  },
  [PersonalPropertyType.AllOther]: {
    label: "All Other",
    icon: "/images/coverage-icons/personal-property/other.webp",
  },
};

export const personalPropertyOptions = Object.entries(
  personalPropertyValues
  // `Object.entries` widens the key back to `string`.
).map(([value, details]) => ({
  ...details,
  value: value as PersonalPropertyType,
}));
